export default [
    {
        path: '/:organisation/errors/400',
        name: 'errors.general',
        component: () => import(/* webpackChunkName: "errors" */ '@/pages/[organisation]/errors/400.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:organisation/errors/403',
        name: 'errors.forbidden',
        component: () => import(/* webpackChunkName: "errors" */ '@/pages/[organisation]/errors/403.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:organisation/errors/404',
        name: 'errors.not-found',
        component: () => import(/* webpackChunkName: "errors" */ '@/pages/[organisation]/errors/404.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:organisation/errors/500',
        name: 'errors.server-error',
        component: () => import(/* webpackChunkName: "errors" */ '@/pages/[organisation]/errors/500.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:organisation/errors/503',
        name: 'errors.service-unavailable',
        component: () => import(/* webpackChunkName: "errors" */ '@/pages/[organisation]/errors/503.vue'),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:organisation/:catchAll(.*)',
        redirect: { name: 'errors.not-found' },
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
    {
        path: '/:catchAll(.*)',
        /*
         * A function, not `{ name: 'errors.not-found' }` like the
         * organisation-level catch-all above. That form works up there because
         * the matched `:organisation` param is carried into the named redirect;
         * a root-level URL has no organisation to carry, so the same shorthand
         * made the router's initial navigation throw
         * `Missing required param "organisation"` inside `app.use(router)` —
         * before the app mounted — and any unknown single-segment URL (for
         * example `/login`, which has never been a route) rendered a blank
         * page. `__my__` is the slug fallback the organisation chooser already
         * uses when a tenant has none.
         */
        redirect: () => ({ name: 'errors.not-found', params: { organisation: '__my__' } }),
        meta: {
            guestRequired: false,
            loginRequired: false,
            permission: '*',
        },
    },
];
